module.exports = __webpack_public_path__ + "static/img/avatar.7d811241.png";